import './App.css';
import { useState, createContext } from 'react';
import Header from './components/header';
import Footer from './components/footer';
import Home from './pages/home';
import About from './pages/about';
import Services from './pages/services';
import SocialMedia from './pages/socialMedia';
import Contact from './pages/contact';
import ContactModal from './components/ContactModal';
// import Spacer from './components/spacer';

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Create context for the modal
export const ModalContext = createContext();

function App() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <ModalContext.Provider value={{ openModal, closeModal }}>
      <div className="App">
        <Header />
        
        <Router>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/social-media" element={<SocialMedia />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </Router>
        
        {/* Modal component */}
        <ContactModal isOpen={isModalOpen} onClose={closeModal} />
        
        {/* <Spacer height={10} /> */}
        <Footer />
      </div>
    </ModalContext.Provider>
  );
}

export default App;